import { render, staticRenderFns } from "./EditIndustrialPropertyList.vue?vue&type=template&id=5e604a4d"
import script from "./EditIndustrialPropertyList.vue?vue&type=script&lang=js"
export * from "./EditIndustrialPropertyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports